import React from 'react';

const Section = ({ title, children }) => (
  <div className="border border-[#E4E4E7] rounded-xl p-6 space-y-3">
    <h3 className="text-base font-bold text-[#17171C]">{title}</h3>
    {children}
  </div>
);

const GuidelineTab = () => (
  <div className="space-y-4 text-sm text-[#3f3f46] leading-relaxed">

    <Section title="Modus Operandi">
      <p className="font-medium text-[#17171C]">Services are blocked in a 2-Step process:</p>
      <ol className="list-decimal list-inside space-y-1 ml-1">
        <li>Removes all the tags from PHP using the <code className="bg-gray-100 px-1 rounded text-xs">ob_start()</code> & <code className="bg-gray-100 px-1 rounded text-xs">ob_end_flush()</code> functions.</li>
        <li>Prevents JS injection after the page load if regex is matched.</li>
      </ol>
      <p>
        The block feature discerns the services with the regex set in the Available Services → Service
        name &amp; Identifier column. Needed Information:
      </p>
      <ul className="list-disc list-inside space-y-1 ml-1">
        <li>Name of Service</li>
        <li>URL of Provider Homepage &amp; the required ReGex or an example of the request to block</li>
      </ul>
      <p>
        If you encountered a problem please contact us{' '}
        <a href="#" className="text-[#7C3BED] underline hover:opacity-80">here</a>.
        {' '}Needed Information:
      </p>
    </Section>

    <Section title="How to block a service">
      <p className="font-medium text-[#17171C]">Follow the steps below to block service(s)</p>
      <ol className="list-decimal list-inside space-y-2 ml-1">
        <li>
          Step 1: Select Compliance Type Opt In or Opt Out in Cookie Bar → General Settings and Save
          the settings.
        </li>
        <li>Step 2: Enable service blocking in Cookie Bar → Block Services</li>
        <li>Step 3: Click on "Add a rule" and select the service you want to block</li>
        <li>
          Step 4: Select 'Allowed with consent' which is basically the compliance type you have set
          in "Step 1" and hit Save.
        </li>
      </ol>
      <p>
        That's it, you have successfully added the service(s) to the block list! If your desired service
        is not on the list, then follow the steps below in order to add a new service to the list
      </p>
    </Section>

    <Section title="How to add a new service">
      <ol className="list-decimal list-inside space-y-2 ml-1">
        <li>Step 1: Navigate to "Available Services" → Add Service</li>
        <li>
          Step 2: Add the service name and RegEx (Proceed, only if you know what you are doing. More
          information about RegEx can be found{' '}
          <a href="https://regex101.com" target="_blank" rel="noopener noreferrer" className="text-[#7C3BED] underline hover:opacity-80">
            here
          </a>)
        </li>
        <li>Step 3: Save, reload and clear the cache.</li>
      </ol>
    </Section>

  </div>
);

export default GuidelineTab;